import { lazy } from 'react';

export const Withdraw = lazy(() => import('./Withdraw.component'));
